import Vue from "vue";
import VueCropper from "vue-cropper";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import axios from "axios";
import JsonViewer from "vue-json-viewer";
import "../src/utils/directives";
import htmlToPdf from "../src/utils/htmlToPdf";
import { ImagePreview, Skeleton, Icon, Lazyload, Loading } from "vant";
import { Image as VanImage } from "vant";
import "vant/lib/image-preview/style/less";
import "vant/lib/skeleton/style/less";
import qs from "qs";
import { encodeString } from "../src/utils/common";
let Base64 = require("js-base64").Base64;
axios.defaults.baseURL = "/api";
// 添加请求拦截器
axios.interceptors.request.use(
  function(config) {
    // if (config.url != "api/image/upload") {
    //   if (config.data && config.data.includes("password")) {
    //     var params = qs.parse(config.data);
    //     console.log(params);
    //     params.password = encodeString(params.password);
    //     if (params.hasOwnProperty("oldPassword")) {
    //       params.oldPassword = encodeString(params.oldPassword);
    //     }
    //     if (params.hasOwnProperty("notpassword")) {
    //       params.notpassword = encodeString(params.notpassword);
    //     }
    //     config.data = qs.stringify(params, { encode: false });
    //     config.url = config.url + "?encode=1";
    //   }
    // }
    if (config.url != "api/image/upload") {
      if (config.data) {
        let encodeField = [
          "password",
          "oldPassword",
          "notpassword",
          "payPassword",
          "idcard",
        ];
        let param = qs.parse(config.data);
        let encodeIt = false;
        for (let k in param) {
          if (encodeField.includes(k)) {
            Object.defineProperty(param, k, {
              value: encodeString(param[k]),
            });
            encodeIt = true;
          }
        }
        if (encodeIt == true) {
          config.url = `${config.url}?encode=1`;
        }
        // config.data = param;
        config.data = encodeRequestParam(param);
      }
    }
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
// axios.defaults.withCredentials = false;

function encodeRequestParam(data) {
  let initData = [];
  for (let k in data) {
    initData.push(`${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`);
  }
  return initData.join("&");
}

Vue.prototype.$axios = axios;
Vue.prototype.$store = store;
Vue.prototype.$bus = new Vue(); // event Bus 用于无关系组件间的通信。
window.Store = store;
window.Router = router;

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueCropper);
Vue.use(JsonViewer);
Vue.use(htmlToPdf);
Vue.use(ImagePreview);
Vue.use(Skeleton);
Vue.use(Icon);
Vue.use(VanImage);
Vue.use(Lazyload);
Vue.use(Loading);
new Vue({
  router,
  Base64,
  store: store,
  render: function(h) {
    return h(App);
  },
}).$mount("#app");
